"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const sitetext_1 = require("../filters/sitetext");
exports.default = vue_1.default.extend({
    name: 'isotope-header',
    props: {
        siteText: {
            type: String,
            default: '',
        },
    },
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
        cssClasses() {
            let classes = ['mar-bottom--md', 'text--capitalize'];
            if (this.isMobile)
                classes.push('mar-top--xl', 'font-medium-heading');
            else
                classes.push('mar-top--2xl', 'font-small-heading');
            return classes;
        },
    },
    mounted() {
        this.$refs.heading.focus();
    },
});
